import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAdminAxiosInstance } from "../../../../api/Admin";

const initialState = {
  currentPage: 1,
  currentPageSize: 10,
  currentFilter: "all",
  sortBy: "",
  sortOrder: "desc",
  search: "",
  isEdit: false,
  showCreateModal: false,
  showDeleteModal: false,
  clearSelection: false,
  selectedId: "",
  isLoading: false,
  showPassword: false,
  categoryData: [],
  imagePreview: "",
  imageName: "",
  iconName: "",
  iconPreview: "",
  editCategoryData: {},
  isImageUploading: false,
};

export const getCategoryEditData = createAsyncThunk(
  "category/edit",
  async (id, { rejectWithValue }) => {
    const api = await getAdminAxiosInstance();
    try {
      const response = await api.get(`category/edit?category_id=${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCategoryEditData.pending, (state) => {
        state.isLoading = true;
        // state.editAdminData = {};
        state.error = null;
      })
      .addCase(getCategoryEditData.fulfilled, (state, action) => {
        state.editCategoryData = action.payload?.data;
      })
      .addCase(getCategoryEditData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.data;
      });
  },
});

export const { updateConfig } = categorySlice.actions;
export default categorySlice.reducer;
